import moment from "moment";
import React, { useMemo } from "react";
import { Line } from "react-chartjs-2";

let colors = ["black", "orange", "green", "darkblue", "blue", "#89d129", "#29c1d1", "darkyellow", "red", "darkgreen", "cyan", "#dfdc90", "#76356", "#76FF65", "#00FF65", "#00FF65", "#d12929"];

const TrendLineMultiDS = ({ data }) => {
	const timelineLabels = useMemo(() => {
		let labels = [];
		if (Object.keys(data).length > 0) {
			let anyKey = Object.keys(data)[0];
			let startX = data[anyKey].startX;
			let endX = data[anyKey].endX;
			let groupByPeriod = data[anyKey].groupByPeriod;
			while (startX < endX) {
				labels.push(moment(startX).format("HH:mm"));
				startX += groupByPeriod;
			}
		}
		return labels;
	}, [data]);

	const builddataData = () => {
		let datasets = [];
		Object.keys(data).forEach((key, index) => {
			datasets.push({
				data: data[key].values,
				backgroundColor: colors[index],
				borderColor: colors[index],
				elements: { point: { radius: 1 } },
				borderWidth: 1,
				label: key,
				lineTension: 0,
			});
		});
		let result = {
			labels: timelineLabels,
			datasets: datasets,
			bezierCurve: false,
		};
		return result;
	};

	return (
		<Line
			data={builddataData()}
			options={{
				responsive: true,
				maintainAspectRatio: false,
				animation: false,
				plugins: {
					legend: {
						display: true,
						position: "top",
					},
				},
			}}
		/>
	);
};

export default TrendLineMultiDS;
